/**
 * 产品装小箱管理组件
 *
 * 提供产品装箱、补码入箱、拆码出箱等操作的管理界面，支持溯源码/外箱码查询、
 * 批次与产品筛选、扫码枪录入、随机生成外箱码、筛选录入等功能。
 *
 * 主要功能：
 * - 搜索过滤：按溯源码、外箱码、关联批次、关联产品进行搜索
 * - 产品装箱（drawerId=2）：将溯源码录入指定小箱，支持手动录入和筛选录入两种方式
 * - 补码入箱（drawerId=3）：向已有小箱中补充录入溯源码
 * - 拆码出箱（drawerId=4）：将溯源码从小箱中拆出，支持溯源码拆箱和小箱码拆箱
 * - 小箱详情（drawerId=1）：查看小箱内的产品列表及图片、规格等信息
 * - 批量拆箱：通过全选勾选多个小箱码后批量执行拆箱操作
 * - 选择箱码：从已有小箱列表中选择外箱码进行装箱/补码
 * - 筛选录入：按起始/截止ID、批次、产品筛选溯源码后批量录入
 *
 * 数据流：
 * - 主列表通过 packing_small_list 接口获取，支持分页
 * - 批次和产品下拉分别通过 batch_select、product_select 获取
 * - 装箱/补码提交调用 packing_small_tostart，若返回 code=101 则提示用户确认覆盖
 * - 拆箱提交调用 packing_unpack，按 type 区分溯源码拆箱(1)和小箱码拆箱(3)
 * - 外箱码随机生成调用 packing_count_round
 * - 溯源码筛选查询调用 qrcode_filter
 *
 * 依赖API：packing_small_list, packing_small_tostart, packing_small_product,
 *          packing_count_round, packing_unpack, qrcode_filter, batch_select, product_select
 */
<!-- 产品装小箱管理 -->
<template>
    <div class="container">
        <div class="header">
            <Input
                class="w300 mr24 mb24"
                type="text"
                v-model="storePrams.qrcode_number"
                placeholder="请输入或扫描溯源码查询"
            ></Input>
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.box_number"
                placeholder="请输入或扫描外箱码查询"
            ></Input>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.batch_id"
                clearable
                filterable
                placeholder="请选择关联批次"
            >
                <Option
                    v-for="item in batchList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.batch_name }}</Option
                >
            </Select>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.product_id"
                clearable
                filterable
                placeholder="请选择关联产品"
            >
                <Option
                    v-for="item in productList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.product_name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearch"
                >确定搜索</Button
            >
        </div>
        <div class="content">
            <div>
                <Button
                    class="theme-bc mr24 mb24 theme-default-color"
                    @click="goPacking"
                    >产品装箱操作</Button
                >
                <Button class="mr24 mb24" type="primary" ghost @click="goRepair"
                    >补码入箱操作</Button
                >
                <Button
                    class="mr24 mb24"
                    type="primary"
                    ghost
                    @click="goUnpacking"
                    >拆码出箱(拆箱操作)</Button
                >
                <Table
                    ref="selection"
                    :columns="columnsTable"
                    :data="dataTable"
                    border
                    @on-selection-change="changeSelection"
                >
                    <template slot-scope="{ row }" slot="count">
                        <Button type="default" @click="goDetails(row)">{{
                            row.count
                        }}</Button>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sb">
                            <Button type="success" ghost @click="goPacking(row)"
                                >装箱</Button
                            >
                            <Button
                                type="warning"
                                ghost
                                @click="goUnpacking(row)"
                                >拆箱</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox
                        class="checkbox-ml"
                        v-model="del_value"
                        @on-change="handleSelectAll"
                        >全选</Checkbox
                    >
                    <span class="mr24 ml24"
                        >已经选择{{ delData.length }}个</span
                    >
                    <Button type="error" ghost @click="goDel">拆箱</Button>
                </div>
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>

        <Drawer
            v-model="drawerModal"
            :title="drawerTitle"
            width="66"
            :styles="styles"
            :mask-closable="false"
        >
            <!-- 详情 -->
            <template v-if="drawerId == 1">
                <Table :columns="columnsDrawer" :data="dataDrawer" border>
                    <template slot-scope="{ row }" slot="product_imgs">
                        <div v-if="row.product_qrcode.product" class="flex-c">
                            <img
                                class="table-img"
                                v-if="row.product_qrcode.product.product_imgs"
                                :src="
                                    row.product_qrcode.product
                                        .show_product_imgs[0]
                                "
                            />
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="product_name">
                        <div v-if="row.product_qrcode">
                            {{
                                row.product_qrcode.product
                                    ? row.product_qrcode.product.product_name
                                    : ""
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="specs">
                        <div v-if="row.product_qrcode">
                            {{
                                row.product_qrcode.product
                                    ? row.product_qrcode.product.specs
                                    : ""
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="qrcode_number">
                        <div v-if="row.product_qrcode">
                            {{
                                row.product_qrcode.product
                                    ? row.product_qrcode.qrcode_number
                                    : ""
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <Button
                            type="primary"
                            ghost
                            @click="goUnpackingTip(row)"
                            >拆箱</Button
                        >
                    </template>
                </Table>
                <div class="page-drawer">
                    <Page
                        :current="pageDrawer.page"
                        :page-size="pageDrawer.limit"
                        :total="totalDrawer"
                        show-elevator
                        show-total
                        @on-change="changeDrawer"
                    />
                </div>
            </template>
            <!-- 产品装箱操作 -->
            <template v-if="drawerId == 2">
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                    @submit.native.prevent
                >
                    <div class="form-header">
                        <img
                            class="wh24 mr12"
                            src="../../assets/information.png"
                        />
                        <div style="color: #ff761d">
                            为规范操作，如果需要装箱的产品之前装过箱，后台装箱需要将该产品拆箱后再装，否则会过滤该产品并提示已装过箱。
                        </div>
                    </div>
                    <FormItem label="外箱码：">
                        <div class="dis-flex">
                            <Input
                                class="w30 mr24"
                                v-model="formData.small_box_number"
                                placeholder="录入已有外箱码"
                                @keydown.enter.native.prevent
                            />
                            <Button type="success" @click="getPackingCountRound"
                                >随机生成</Button
                            >
                            <Button
                                class="theme-bc ml24 theme-default-color"
                                @click="goSelectCode"
                                >选择箱码</Button
                            >
                        </div>
                    </FormItem>
                    <FormItem label="录入方式：">
                        <RadioGroup
                            v-model="formData.type"
                            type="button"
                            @on-change="changeFilter"
                        >
                            <Radio label="1">录入溯源码</Radio>
                            <Radio label="2">筛选录入</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="录入溯源码：">
                        <div class="dis-flex">
                            <Input
                                @input="handleInputChange"
                                @keydown.enter.native.prevent
                                class="w30 mr24"
                                type="textarea"
                                v-model="qrcode_number"
                                :autosize="{ minRows: 10 }"
                                placeholder="录入溯源码，发货码，一行一个，支持手动和扫码枪扫码录入"
                            ></Input>
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                "
                            >
                                <div>支持手动和扫码枪扫码录入。</div>
                                <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                    "
                                    @click="setNull"
                                >
                                    <img
                                        src="@/assets/blank.png"
                                        alt=""
                                        style="
                                            display: block;
                                            margin-right: 6px;
                                        "
                                    />
                                    <div>置空</div>
                                </div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
                <div class="drawer-footer">
                    <Button class="mr24" @click="cancelDrawer">取消</Button>
                    <Button
                        class="theme-bc theme-default-color"
                        @click="submitDrawer"
                        >确定装箱</Button
                    >
                </div>
            </template>
            <!-- 补码入箱操作 -->
            <template v-if="drawerId == 3">
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                    @submit.native.prevent
                >
                    <div class="form-header">
                        <img
                            class="wh24 mr12"
                            src="../../assets/information.png"
                        />
                        <div style="color: #ff761d">
                            为规范操作，如果需要装箱的产品之前装过箱，后台装箱需要将该产品拆箱后再装，否则会过滤该产品并提示已装过箱。
                        </div>
                    </div>
                    <FormItem label="外箱码：">
                        <div class="dis-flex">
                            <Input
                                class="w30 mr24"
                                v-model="formData.small_box_number"
                                placeholder="录入要补码的外箱码"
                            />
                            <Button
                                class="theme-bc theme-default-color"
                                @click="goSelectCode"
                                >选择箱码</Button
                            >
                        </div>
                    </FormItem>
                    <FormItem label="录入方式：">
                        <RadioGroup
                            v-model="formData.type"
                            type="button"
                            @on-change="changeFilter"
                        >
                            <Radio label="1">录入溯源码</Radio>
                            <Radio label="2">筛选录入</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="录入溯源码：">
                        <div class="dis-flex">
                            <Input
                                @input="handleInputChange"
                                class="w30 mr24"
                                type="textarea"
                                v-model="qrcode_number"
                                :autosize="{ minRows: 10 }"
                                placeholder="录入溯源码，发货码，一行一个，支持手动和扫码枪扫码录入"
                            ></Input>
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                "
                            >
                                <div>支持手动和扫码枪扫码录入。</div>
                                <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                    "
                                    @click="setNull"
                                >
                                    <img
                                        src="@/assets/blank.png"
                                        alt=""
                                        style="
                                            display: block;
                                            margin-right: 6px;
                                        "
                                    />
                                    <div>置空</div>
                                </div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
                <div class="drawer-footer">
                    <Button class="mr24" @click="cancelDrawer">取消</Button>
                    <Button
                        class="theme-bc theme-default-color"
                        @click="submitDrawer"
                        @keyup.enter.native.prevent
                        >补码入箱</Button
                    >
                </div>
            </template>
            <!-- 拆码出箱(拆箱操作) -->
            <template v-if="drawerId == 4">
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                    @submit.native.prevent
                >
                    <FormItem label="录入方式：">
                        <RadioGroup v-model="formData.type" type="button">
                            <Radio label="1">溯源码拆箱</Radio>
                            <Radio label="3">小箱码拆箱</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="录入溯源码：">
                        <div class="dis-flex">
                            <Input
                                @input="handleInputChange"
                                class="w30 mr24"
                                type="textarea"
                                v-model="qrcode_number"
                                :autosize="{ minRows: 10 }"
                                placeholder="录入溯源码，小箱码，大箱码，发货码，一行一个，支持手动和扫码枪扫码录入"
                            ></Input>
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                "
                            >
                                <div>支持手动和扫码枪扫码录入。</div>
                                <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                    "
                                    @click="setNull"
                                >
                                    <img
                                        src="@/assets/blank.png"
                                        alt=""
                                        style="
                                            display: block;
                                            margin-right: 6px;
                                        "
                                    />
                                    <div>置空</div>
                                </div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
                <div class="drawer-footer">
                    <Button class="mr24" @click="cancelDrawer">取消</Button>
                    <Button
                        class="theme-bc theme-default-color"
                        @click="submitDrawer"
                        @keyup.enter.native.prevent
                        >确定</Button
                    >
                </div>
            </template>
        </Drawer>
        <!-- 选择箱码 -->
        <Drawer
            v-model="selectCodeModal"
            title="选择箱码"
            width="66"
            :styles="styles"
        >
            <Select
                class="w200 mr24 mb24"
                v-model="pageCode.product_id"
                clearable
                filterable
                placeholder="关联产品"
            >
                <Option
                    v-for="item in productList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.product_name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearchCode"
                >确定搜索</Button
            >
            <Table :columns="columnsCode" :data="dataCode" border></Table>
            <div class="page-drawer">
                <Page
                    :current="pageCode.page"
                    :page-size="pageCode.limit"
                    :total="totalCode"
                    show-elevator
                    show-total
                    @on-change="pageChangeCode"
                />
            </div>
            <div class="drawer-footer">
                <Button class="mr24" @click="cancelCode">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitCode"
                    >确定</Button
                >
            </div>
        </Drawer>
        <!-- 筛选录入 -->
        <Drawer
            v-model="filterModal"
            title="筛选录入"
            width="66"
            :styles="styles"
            @on-close="closeFilter"
        >
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="pageFilter.start_id"
                placeholder="起始ID"
            ></Input>
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="pageFilter.end_id"
                placeholder="截止ID"
            ></Input>
            <Select
                class="w200 mr24 mb24"
                v-model="pageFilter.batch_id"
                clearable
                filterable
                placeholder="请选择批次"
            >
                <Option
                    v-for="item in batchList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.batch_name }}</Option
                >
            </Select>
            <Select
                class="w200 mr24 mb24"
                v-model="pageFilter.product_id"
                clearable
                filterable
                placeholder="请选择产品"
            >
                <Option
                    v-for="item in productList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.product_name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearchFilter"
                >确定搜索</Button
            >
            <Table
                ref="selection"
                :columns="columnsFilter"
                :data="dataFilter"
                border
                @on-selection-change="changeSelectionFilter"
            >
                <template slot-scope="{ row }" slot="batch_name">
                    <div>{{ row.batch ? row.batch.batch_name : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="product_name">
                    <div>{{ row.product ? row.product.product_name : "" }}</div>
                </template>
            </Table>
            <div class="page-drawer">
                <Page
                    :current="pageFilter.page"
                    :page-size="pageFilter.limit"
                    :total="totalFilter"
                    show-elevator
                    show-total
                    @on-change="pageChangeFilter"
                />
            </div>
            <div class="drawer-footer">
                <Button class="mr24" @click="cancelFilter">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitFilter"
                    >确定</Button
                >
            </div>
        </Drawer>
    </div>
</template>

<script>
import {
    packing_small_list,
    packing_small_tostart,
    packing_small_product,
    packing_count_round,
    packing_unpack,
    qrcode_filter,
    batch_select,
    product_select,
} from "@/api/index";
export default {
    data() {
        return {
            qrcode_number: "",
            small_box_number: "",
            storePrams: {
                page: 1,
                limit: 10,
                qrcode_number: "",
                box_number: "",
                batch_id: "",
                product_id: "",
            },
            total: 0,
            totalCode: 0,
            batchList: [],
            productList: [],
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { type: "index", width: 60, align: "center" },
                {
                    title: "小箱外箱码",
                    key: "small_box_number",
                    align: "center",
                },
                { title: "关联大箱码", key: "big_box_number", align: "center" },
                { title: "装箱数量", slot: "count", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            drawerModal: false,
            drawerTitle: "",
            drawerId: 0,
            columnsDrawer: [
                { type: "index", width: 60, align: "center" },
                { title: "图片", slot: "product_imgs", align: "center" },
                { title: "产品名称", slot: "product_name", align: "center" },
                { title: "规格", slot: "specs", align: "center" },
                { title: "产品编码", slot: "qrcode_number", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataDrawer: [],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            pageDrawer: {
                page: 1,
                limit: 10,
            },
            totalDrawer: 0,
            formData: {
                qrcode_number: [],
                small_box_number: "",
                is_round: 0,
                is_exist: 0,
                type: "1",
            },
            styles: {
                height: "calc(100% - 55px)",
                overflow: "auto",
                paddingBottom: "53px",
                position: "static",
            },
            selectCodeModal: false,
            dataCode: [],
            pageCode: {
                page: 1,
                limit: 10,
                product_id: "",
            },
            filterModal: false,
            pageFilter: {
                page: 1,
                limit: 10,
                start_id: "",
                end_id: "",
                product_id: "",
                batch_id: "",
            },
            totalFilter: 0,
            columnsFilter: [
                { type: "selection", width: 60, align: "center" },
                { title: "ID号", key: "id", align: "center" },
                { title: "溯源码编码", key: "qrcode_number", align: "center" },
                { title: "批次名称", slot: "batch_name", align: "center" },
                { title: "产品名称", slot: "product_name", align: "center" },
            ],
            dataFilter: [],
            filter_data: "",
            selectedId: null, // 存储选中的ID
        };
    },
    mounted() {
        this.getList();
        this.getBatchSelect();
        this.getProductSelect();
    },
    computed: {
        columnsCode() {
            return [
                {
                    title: "选择",
                    width: 100,
                    render: (h, params) => {
                        return h("Checkbox", {
                            props: {
                                value: this.selectedId === params.row.id,
                            },
                            on: {
                                "on-change": () => this.selectRow(params.row),
                            },
                        });
                    },
                },
                { title: "小箱码", key: "small_box_number", align: "center" },
                { title: "大箱码", key: "big_box_number", align: "center" },
                { title: "箱内产品数量", key: "count", align: "center" },
            ];
        },
    },
    methods: {
        selectRow(e) {
            this.selectedId = e.id;
            this.formData.small_box_number = e.small_box_number;
        },
        getFilter() {
            qrcode_filter(this.pageFilter)
                .then((res) => {
                    this.dataFilter = res.data.data;
                    this.totalFilter = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        changeSelectionFilter(e) {
            this.filter_data = e
                .map((item) => item.qrcode_number) // 提取所有值
                .filter((code) => code && code.trim()) // 过滤空值
                .filter((code, index, self) => self.indexOf(code) === index) // 去重
                .join("\n");
        },
        pageChangeFilter(index) {
            this.pageFilter.page = index;
            this.getFilter();
        },
        goSearchFilter() {
            this.pageFilter.page = 1;
            this.getFilter();
        },
        submitFilter() {
            if (this.qrcode_number) {
                this.qrcode_number += "\n" + this.filter_data;
            } else {
                this.qrcode_number += this.filter_data;
            }
            if (!this.filter_data) {
                this.$Message.error("请选择溯源码编码");
                return;
            }
            this.formData.type = "1";
            this.filterModal = false;
        },
        cancelFilter() {
            this.formData.type = "1";
            this.filterModal = false;
        },
        closeFilter() {
            this.formData.type = "1";
        },
        changeFilter(e) {
            if (e == 2) {
                this.pageFilter.page = 1;
                this.pageFilter.limit = 10;
                this.pageFilter.start_id = "";
                this.pageFilter.end_id = "";
                this.pageFilter.product_id = "";
                this.pageFilter.batch_id = "";
                this.getFilter();
                // 延时器
                setTimeout(() => {
                    this.filterModal = true;
                }, 300);
            }
        },
        submitCode() {
            if (!this.formData.small_box_number) {
                this.$Message.error("请选择小箱码");
                return;
            }
            this.selectCodeModal = false;
        },
        cancelCode() {
            this.selectCodeModal = false;
        },
        getCode() {
            packing_small_list(this.pageCode)
                .then((res) => {
                    this.dataCode = res.data.data;
                    this.totalCode = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChangeCode(index) {
            this.pageCode.page = index;
            this.getCode();
        },
        goSearchCode() {
            this.pageCode.page = 1;
            this.getCode();
        },
        goSelectCode() {
            this.getCode();
            this.selectCodeModal = true;
        },
        goUnpackingTip(row) {
            var qrcode_number = row.qrcode_number
                .split("\n")
                .map((item) => (item === "" ? null : item)) // 将空字符串转为 null
                .filter((item) => item !== null); // 过滤掉所有 null 值
            this.$Modal.confirm({
                title: "是否将此溯源码拆出！",
                content: "将此溯源码从小箱中拆出",
                onOk: () => {
                    var data = {
                        type: 1,
                        qrcode_number: qrcode_number,
                    };
                    packing_unpack(data)
                        .then((res) => {
                            this.getPackingSmallProduct();
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        setNull() {
            this.qrcode_number = "";
            this.formData.qrcode_number = [];
        },
        // 产品装小箱列表
        getList() {
            packing_small_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 详情
        getPackingSmallProduct() {
            packing_small_product({ small_box_number: this.small_box_number })
                .then((res) => {
                    this.dataDrawer = res.data.data;
                    this.totalDrawer = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 批次下拉
        getBatchSelect() {
            batch_select()
                .then((res) => {
                    this.batchList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 产品下拉
        getProductSelect() {
            product_select()
                .then((res) => {
                    this.productList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        changeDrawer(index) {
            this.pageDrawer.page = index;
            this.getPackingSmallProduct();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        goDetails(row) {
            this.small_box_number = row.small_box_number;
            this.getPackingSmallProduct();
            this.drawerTitle = row.small_box_number + "小箱详情";
            this.drawerId = 1;
            setTimeout(() => {
                this.drawerModal = true;
            }, 300);
        },
        goPacking(row) {
            if (row.id) {
                this.formData.small_box_number = row.small_box_number;
            } else {
                this.formData.small_box_number = "";
            }
            this.formData.is_exist = 0;
            this.formData.qrcode_number = [];
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "产品装箱操作";
            this.drawerId = 2;
            this.formData.type = "1";
            this.drawerModal = true;
        },
        goRepair() {
            this.formData.is_exist = 1;
            this.formData.qrcode_number = [];
            this.formData.small_box_number = "";
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "补码入箱操作";
            this.drawerId = 3;
            this.formData.type = "1";
            this.drawerModal = true;
        },
        goUnpacking(row) {
            if (row.id) {
                this.formData.type = "3";
                this.qrcode_number = row.small_box_number;
            } else {
                this.qrcode_number = "";
            }
            this.formData.qrcode_number = [];
            this.drawerTitle = "拆码出箱(拆箱操作)";
            this.drawerId = 4;
            this.drawerModal = true;
        },
        goDel() {
            if (this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "拆码出箱！",
                content: "将小箱码从小箱中拆出",
                onOk: () => {
                    var del_id = [];
                    this.delData.forEach((item) => {
                        del_id.push(item.small_box_number);
                    });
                    this.del_id = del_id.join(",");
                    var data = {
                        type: 3,
                        small_box_number: this.del_id,
                    };
                    packing_unpack(data)
                        .then((res) => {
                            this.getList();
                            this.del_value = false;
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        getPackingCountRound() {
            this.formData.is_round = 1;
            packing_count_round()
                .then((res) => {
                    this.formData.small_box_number = res.data;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 确定
        submitDrawer() {
            if (this.qrcode_number) {
                this.formData.qrcode_number = this.qrcode_number
                    .split("\n")
                    .map((item) => (item === "" ? null : item)) // 将空字符串转为 null
                    .filter((item) => item !== null); // 过滤掉所有 null 值
            }
            // 拆码出箱(拆箱操作)
            if (this.drawerId == 4) {
                if (this.formData.type == 1) {
                    var data = {
                        type: this.formData.type,
                        qrcode_number: this.formData.qrcode_number,
                    };
                } else if (this.formData.type == 3) {
                    var data = {
                        type: this.formData.type,
                        small_box_number: this.formData.qrcode_number,
                    };
                }
                packing_unpack(data)
                    .then((res) => {
                        this.getList();
                        this.drawerModal = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
                return;
            }
            var data = {
                is_exist: this.formData.is_exist,
                is_round: this.formData.is_round,
                qrcode_number: this.formData.qrcode_number,
                small_box_number: this.formData.small_box_number,
            };
            packing_small_tostart(data)
                .then((res) => {
                    if (res.data.code == 101) {
                        this.$Modal.confirm({
                            content: res.msg,
                            onOk: () => {
                                this.formData.is_exist = 1;
                                this.submitDrawer();
                            },
                            onCancel: () => {},
                        });
                        return;
                    }
                    this.getList();
                    this.drawerModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelDrawer() {
            this.drawerModal = false;
        },
        handleInputChange(e) {
            // 获取当前输入框的值
            const inputValue = e.target ? e.target.value : e;
            // 按换行符分割为数组（处理多行输入）
            const lines = inputValue.split("\n");
            // 用于存储处理后的所有码
            const allCodes = [];
            // 同时匹配 ?q=xxx 和 #xxx 两种链接
            const urlPattern = /https?:\/\/[^\s]+?(?:\?q=|#)([\w\-.]+)/g;
            // 处理每一行数据
            lines.forEach((line) => {
                // 处理行内的所有URL
                let match;
                let lastIndex = 0;
                const results = [];
                // 1. 提取行内所有URL的编码
                while ((match = urlPattern.exec(line)) !== null) {
                    // 添加URL前可能存在的非URL文本
                    if (match.index > lastIndex) {
                        const textBefore = line
                            .substring(lastIndex, match.index)
                            .trim();
                        if (textBefore) results.push(textBefore);
                    }
                    // 添加提取到的编码（两种分隔符捕获结果都存在 match[1]）
                    results.push(match[1]);
                    // 更新lastIndex
                    lastIndex = match.index + match[0].length;
                }
                // 2. 添加最后一个URL后的剩余文本
                if (lastIndex < line.length) {
                    const textAfter = line.substring(lastIndex).trim();
                    if (textAfter) results.push(textAfter);
                }
                // 3. 处理没有URL的直接输入码
                if (results.length === 0) {
                    const directCodeMatch = line.match(/^([\w\-.]+)\s*$/);
                    if (directCodeMatch) {
                        results.push(directCodeMatch[1]);
                    } else {
                        results.push(line); // 保留原始行内容
                    }
                }
                // 收集当前行的所有结果
                allCodes.push(...results);
            });
            // 更新v-model绑定的数据（去除空行）
            this.qrcode_number = allCodes
                .filter((code) => code.trim() !== "")
                .join("\n");
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.form-header {
    padding: 24px;
    display: flex;
    align-items: center;
}
.wh24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.page-drawer {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.table-img {
    margin: 12px 0;
    width: 50px;
    height: 50px;
}
.w30 {
    width: 30vw;
}
.dis-flex {
    display: flex;
}
.checkbox-ml {
    margin-left: 20px !important;
}
.drawer-footer {
    padding: 12px 24px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    text-align: right;
    background: #fff;
}
::v-deep .ivu-input-search {
    background: #53c41a !important;
    border-color: #53c41a !important;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    color: #ffffff;
    box-shadow: none;
    z-index: 1;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper {
    margin-right: 24px;
}
</style>